import PrivilegesModel from '#model/PrivilegesModel'
import { useApiClient } from '#context/ApiContext'
import { useNotifications } from '#context/NotificationContext'
import { useInstanceOf } from 'eilmer-mvvm/react'

export default class PrivilegesViewModel {

  constructor(apiClient, notificationsProvider) {
    this.model = new PrivilegesModel(apiClient)
    this.notifications = notificationsProvider
    this.entity = new PrivilegesModel.Privilege()
    this.editing = false
    this.loadEntities()
  }

  async loadEntities() {
    try {
      this.entities = await this.model.getPrivileges()
    } catch (err) {
      console.error(err)
      this.notifications.error(err.message)
    }
  }

  doEditEntity(entity) {
    this.entity = new PrivilegesModel.Privilege(entity)
    this.editing = true
  }

  doCancelEdit() {
    this.editing = false
  }

  async doSaveEntity(entity) {
    try {
      if (entity.isNew()) {
        const result = await this.model.createPrivilege(entity)
        this.editing = false
        this.loadEntities()
        return result
      } else {
        const result = await this.model.updatePrivilege(entity)
        this.editing = false
        this.loadEntities()
        return result
      }
    } catch (err) {
      console.error(err)
      this.notifications.error(err.message)
    }
  }

  async doDeleteEntity(entity) {
    if (await this.notifications.confirm('Are you sure you\'d like to delete this entity?')) {
      try {
        const result = await this.model.deletePrivilege(entity)
        this.loadEntities()
        return result
      } catch (err) {
        console.error(err)
        this.notifications.error(err.message)
      }
    }
  }

  get fields() {
    return [
      { key: 'privilege_id', label: "ID", _style: { width: '6%'}, _classes: 'bg-light text-dark' },
      { key: 'name', _style: { width: '25%'} },
      { key: 'description' },
      {
        key: 'actions',
        label: '',
        _style: { width: '70px' },
        filter: false
      }
    ]
  }

}

PrivilegesViewModel.useInstance = function() {
  return useInstanceOf(PrivilegesViewModel, useApiClient(), useNotifications())
}
